export interface IOperationJson<N extends string = string> {
  operation_name: N;
}

export abstract class Operation<N extends string = string>
{
  // public static getOperationName<N extends string>(this: OperationConstructor<N>): N {
  //   throw new Error(`getOperationName must be implemented in ${this.name}`);
  // }

  public abstract get operation_name(): N;

  public constructor() {
    // const ctor = this.constructor as OperationConstructor<N>;
    // this.operation_name = ctor.getOperationName();
  }

  public abstract getUserMessage(): string;

  public abstract toJson(): IOperationJson<N>;

  public abstract buildUserMetadata(): Record<string, unknown>;

  public getUserMetadata(): Record<string, unknown> | undefined
  {
    const metadata = this.buildUserMetadata();
    if(!metadata) { return undefined; }

    const key = `${this.operation_name}_operation`;
    // Match the server's metadata envelope (agent_models.py Operation.get_user_metadata):
    // artifacts are keyed by `<operation_name>_operation` and hold an ARRAY of
    // artifact objects. The artifact loaders (e.g. SearchListingsFilters.loadArtifact)
    // require Array.isArray(artifacts); a bare object renders empty until the
    // server's authoritative message overwrites it.
    return { [key]: [metadata] }
  }
}
